import { useMemo } from 'react';

import { Spacer } from '@/components/Spacer';
import { CenteredText } from '@/layout/PageLayout';
import { addListIdToObjectList } from '@/utils/addListIdToObjectList';

import { StyledTips } from './styles';

import { ItineraryTip } from '../ItineraryTip/ItineraryTip';

import type { Content } from '@/types/content';

interface ItineraryTipsCarouselProps {
  tips: Content[];
  location: string;
}

function ItineraryTips({ tips, location }: ItineraryTipsCarouselProps) {
  const tipsWithListId = useMemo(() => addListIdToObjectList(tips), [tips]);

  return (
    <>
      <CenteredText>
        <h3>Our tips for {location}</h3>
      </CenteredText>
      <Spacer size="lg" />
      <StyledTips>
        {tipsWithListId.map((tip) => (
          <ItineraryTip key={tip.listId} content={tip} />
        ))}
      </StyledTips>
    </>
  );
}

export { ItineraryTips };
